import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/Carousel.css';

export default function Carousel (props) {
  
  const images = [
    props.image1,
    props.image2,
    props.image3,
  ];
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 3500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    adaptiveHeight: true
  };

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {images.map((img, index) => (
          <div key={index}>
            <img 
              src={img} 
              alt={`Lot ${index + 1}`} 
              className="carousel-image"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};
